import React from 'react';
import { AlertCircle } from 'lucide-react';
import './ValidatedInput.css';

interface ValidatedInputProps {
  label: string;
  type?: 'text' | 'email' | 'tel' | 'url';
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  error?: string;
  success?: string;
  helperText?: string;
  disabled?: boolean;
  readOnly?: boolean;
  maxLength?: number;
  className?: string;
  required?: boolean;
}

const ValidatedInput: React.FC<ValidatedInputProps> = ({
  label,
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  success,
  helperText,
  disabled = false,
  readOnly = false,
  maxLength,
  className = '',
  required = false,
}) => {
  return (
    <div className={`form-group ${className}`}>
      <label className="label">
        {label} {required && <span className="required-asterisk">*</span>}
        {maxLength && value.length > 0 && (
          <span className="character-counter">
            {value.length} / {maxLength}
          </span>
        )}
        {error && (
          <span className="validation-icon error" title={error}>
            <AlertCircle size={14} />
          </span>
        )}
      </label>
      <input
        type={type}
        className={`input ${readOnly ? 'readonly-field' : ''} ${readOnly && !value ? 'empty-field' : ''} ${!readOnly && !value ? 'editable-empty' : ''} ${error ? 'input-error' : ''}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        maxLength={maxLength}
      />
      {error && <small className="error-text">{error}</small>}
      {!error && success && <small className="success-text">{success}</small>}
      {!error && !success && helperText && <small className="helper-text">{helperText}</small>}
    </div>
  );
};

export default ValidatedInput;
